import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { connect } from 'react-redux';

// components
import PaymentError from '../CheckoutPaymentError';
import CheckoutCreditCardListWrapper from './CheckoutCreditCardListWrapper';
import CheckoutCreditCardForm from './CheckoutCreditCardForm';
import LocalSpinner from '../../shared/components/LocalSpinner';

import { isAddingCreditCard } from '../../reducers/checkoutPaymentReducer';
import { buyerHasCreditCards, isBrainTreeSandBoxError } from '../../helpers/checkoutPayment';

import ctaStyles from '../../components/shared/styles/checkoutCTAButton.scss';
import styles from './styles/CheckoutCreditCards.scss';

export function CheckoutCreditCardsComponent({
    viewer,
    buyer,
    wrapperClass = '',
    creditCardError,
    isAddingCC,
    checkoutPaymentErrors,
    onValidationUpdate,
    onValidationError,
    onCreditCardMethodSelect,
    expandableCardList,
    transaction,
    isPaymentLoading,
}) {
    const shouldAddNewCard = !buyerHasCreditCards({ buyer }) && isAddingCC;
    const sharedProps = {
        viewer,
        buyer,
        checkoutPaymentErrors,
        onValidationUpdate,
        onValidationError,
    };

    if (isPaymentLoading) {
        return (
            <div className={wrapperClass}>
                <LocalSpinner wrapperClass={styles.spinnerWrapper} />
            </div>
        );
    }

    return (
        <div className={wrapperClass}>
            {(!!creditCardError || isBrainTreeSandBoxError(viewer, transaction)) && (
                <PaymentError viewer={viewer} transaction={transaction} />
            )}
            {shouldAddNewCard ? (
                <CheckoutCreditCardForm {...sharedProps} wrapperClass={ctaStyles.singleForm} />
            ) : (
                <CheckoutCreditCardListWrapper
                    {...sharedProps}
                    transaction={transaction}
                    onCreditCardMethodSelect={onCreditCardMethodSelect}
                    expandableCardList={expandableCardList}
                />
            )}
        </div>
    );
}

CheckoutCreditCardsComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    buyer: PropTypes.object.isRequired,
    transaction: PropTypes.object.isRequired,
    wrapperClass: PropTypes.string,
    creditCardError: PropTypes.string,
    isAddingCC: PropTypes.bool.isRequired,
    checkoutPaymentErrors: PropTypes.object.isRequired,
    onValidationUpdate: PropTypes.func.isRequired,
    onValidationError: PropTypes.func.isRequired,
    onCreditCardMethodSelect: PropTypes.func,
    expandableCardList: PropTypes.bool,
    isPaymentLoading: PropTypes.bool,
};

const ConnectedCheckoutCreditCards = connect(({ payment }) => ({
    creditCardError: payment.creditCardError,
    isAddingCC: isAddingCreditCard(payment),
}))(CheckoutCreditCardsComponent);

export default createFragmentContainer(ConnectedCheckoutCreditCards, {
    viewer: graphql`
        fragment CheckoutCreditCards_viewer on Viewer {
            ...CheckoutCreditCardListWrapper_viewer
            ...CheckoutCreditCardForm_viewer
            ...CheckoutPaymentError_viewer
            ...checkoutPayment_viewer
        }
    `,
    buyer: graphql`
        fragment CheckoutCreditCards_buyer on User {
            ...CheckoutCreditCardListWrapper_buyer
            ...CheckoutCreditCardForm_buyer
            ...checkoutPayment_buyer
        }
    `,
    transaction: graphql`
        fragment CheckoutCreditCards_transaction on Transaction {
            ...checkoutPayment_transaction
            ...CheckoutPaymentError_transaction
        }
    `,
});
